// extracted by mini-css-extract-plugin
export default {"scroll-up-button":"scroll-up-button_scroll-up-button__fI5I8"};